import React from 'react'
import {Router} from './Router'
import 'lib/hotnessNotifier'
import {CoreContext} from './CoreContext'
import {DataProvider} from 'data/DataProvider'
import {logErrorBoundActivation} from 'lib/sentry'
import {ErrorPage} from 'common/ErrorPage'
import {LocaleProvider} from './LocaleProvider'

export class CoreApp extends React.PureComponent {
  state = {
    error: null,
    errorInfo: null,
    sentryEventId: null
  }

  componentDidCatch (error, errorInfo) {
    this.setState({error, errorInfo})
    // see https://sentry.io/ridewithgpscom/rwgps-ui/getting-started/javascript-react/
    // for a full explanation
    logErrorBoundActivation(error, errorInfo)
      .then(sentryEventId => this.setState({sentryEventId}))
  }

  render () {
    const {error, errorInfo, sentryEventId} = this.state
    if (error) {
      return <ErrorPage error={error} errorInfo={errorInfo} sentryEventId={sentryEventId} />
    }
    return (
      <CoreContext.Provider value>
        <DataProvider>
          <LocaleProvider>
            <Router />
          </LocaleProvider>
        </DataProvider>
      </CoreContext.Provider>
    )
  }
}
